export const palette = {
  gray: {
    100: "#f8f9fa",
    200: "#e9ecef",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },
};

export const sizes = {
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
  },
  font: {
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "20px",
    xl: "24px",
  },
  radius: {
    sm: "4px",
    md: "8px",
    lg: "16px",
  },
};

export const light = {
  palette,
  mode: "light",
  colors: {
    primary: "orange",
    secondary: "#282c34",
    background: "#fff",
    text: "#000000",
    card: palette.gray[200],
  },
};

export const dark = {
  palette,
  mode: "dark",
  colors: {
    primary: "orange",
    secondary: "#282c34",
    background: "#191919",
    text: "#fff",
    card: palette.gray[900],
  },
};
